
<template>
  <!--投诉管理-->
  <div>
    <a-tabs v-model="tabType" type="card">
      <a-tab-pane v-for="item of tabsList" :key="item.key" :tab="item.label">
        <appeal v-if="tabType === item.key" :tabType="tabType"></appeal>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import appeal from '@/components/package/appeal.vue';
export default {
  components: {
    appeal
  },
  name: 'complain',
  data () {
    return {
      tabType: '1',
      tabsList: [
        { label: '用户投诉', key: '1' },
        { label: '群聊投诉', key: '2' },
        { label: '动态投诉', key: '3' },
        { label: '评论回复投诉', key: '4' }
      ],
      loading: false
    };
  },
  created () {
  },
  methods: {
  }
};
</script>
